var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 40C32.7614 40 35.2614 38.8807 37.0711 37.0711C38.8807 35.2614 40 32.7614 40 30C40 27.2386 38.8807 24.7386 37.0711 22.9289C35.2614 21.1193 32.7614 20 30 20C27.2386 20 24.7386 21.1193 22.9289 22.9289C21.1193 24.7386 20 27.2386 20 30C20 32.7614 21.1193 35.2614 22.9289 37.0711C24.7386 38.8807 27.2386 40 30 40Z",
    stroke: "#030C21",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 36.5C30.6904 36.5 31.25 35.9404 31.25 35.25C31.25 34.5597 30.6904 34 30 34C29.3097 34 28.75 34.5597 28.75 35.25C28.75 35.9404 29.3097 36.5 30 36.5Z",
    fill: "#030C21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24V32",
    stroke: "#030C21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.da36abe3.svg";
export { ForwardRef as ReactComponent };